import get from 'lodash/get'
import { createSelector } from 'reselect'
import { getState } from '@/store/reducers'

export const getActivitiLog = createSelector(
  getState,
  (state) => get(state, 'actionLog', {}),
)

export const getExportFileStatus = createSelector(
  getActivitiLog,
  (settings) => get(settings, 'fileExportStatus', []),
)

export const getLoading = createSelector(
  getActivitiLog,
  (settings) => get(settings, 'loading'),
)

export const getTableData = createSelector(
  getActivitiLog,
  (settings) => get(settings, 'data', []),
)

export const getSelector = createSelector(
  getActivitiLog,
  (settings) => get(settings, 'selector', []),
)

export const getEventTypes = createSelector(
  getActivitiLog,
  (settings) => get(settings, 'eventTypes'),
)

export const getEventStatus = createSelector(
  getActivitiLog,
  (settings) => get(settings, 'eventStatus'),
)

export const getSelectedElement = createSelector(
  getActivitiLog,
  (settings) => get(settings, 'selectedElement'),
)

export const getEventData = createSelector(
  getActivitiLog,
  (settings) => get(settings, 'eventData'),
)

export const getTableParameters = createSelector(
  getActivitiLog,
  (settings) => get(settings, 'table', {}),
)

export const getActivitiLogDictinory = createSelector(
  getActivitiLog,
  (settings) => get(settings, 'dictionaryTable', {}),
)

export const getActivitiLogFilterValue = createSelector(
  getActivitiLog,
  (settings) => get(settings, 'activitiLogFilterValue', {}),
)

export const getDatesRange = createSelector(
  getActivitiLog,
  (settings) => get(settings, 'dates', {}),
)
